import { Container } from '@design-system/container';
import { FluidGrid } from '@design-system/fluid-grid';
import { PageBlock } from '@design-system/page-block';
import { Typography } from '@design-system/typography';
import React, { forwardRef } from 'react';

import { ItemListingDefaultProps } from './models';

const ItemListingDefault = forwardRef<HTMLDivElement, ItemListingDefaultProps>(
  (
    {
      itemsAmount,
      itemsName,
      fluidGrid,
      items,
      filters,
      text,
      typographyUI,
      pageBlock,
      id,
      uid,
    },
    ref
  ) =>
    itemsAmount > 0 ? (
      <PageBlock
        {...pageBlock}
        className="item-listing-default-block"
        id={id}
        componentUid={uid}
        ref={ref}
      >
        {filters ? (
          <div className="item-listing-default-block__counter">
            <Typography
              content={`${itemsName} (${itemsAmount})`}
              variant="headline"
            />
          </div>
        ) : null}
        <FluidGrid {...fluidGrid}>{items}</FluidGrid>
      </PageBlock>
    ) : (
      filters && (
        <Container maxWidth="full-width" className="filter-no-results">
          <Typography
            content={text}
            variant={typographyUI.variant}
            size={typographyUI.size}
            weight={typographyUI.weight}
            tag={typographyUI.tag}
            align={typographyUI.align}
            className="filter-no-results__text"
          />
        </Container>
      )
    )
);

export default ItemListingDefault;
